module.exports = __webpack_public_path__ + "img/TN.76396bd7.svg";